module.exports = __webpack_public_path__ + "img/hire.da49fa35.jpeg";